var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "20", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.867 10c0-.568-.059-1.122-.17-1.656L19.5 6.732l-1.967-3.464-2.283.786a7.813 7.813 0 0 0-2.813-1.657L11.967 0H8.033l-.472 2.396c-1.043.348-2 .913-2.81 1.657l-2.284-.785L.5 6.732l1.804 1.612a8.054 8.054 0 0 0 0 3.312L.5 13.268l1.967 3.464 2.283-.786a7.813 7.813 0 0 0 2.813 1.657L8.033 20h3.934l.472-2.396a7.83 7.83 0 0 0 2.81-1.657l2.284.786 1.967-3.464-1.804-1.613c.112-.535.171-1.09.171-1.657V10zM10 14c-2.173 0-3.934-1.79-3.934-4S7.826 6 10 6c2.173 0 3.934 1.79 3.934 4s-1.76 4-3.934 4z", fill: "#191E23" })
  );
});